import React from 'react';
import { DivCardContainer, DivLoaderContainer, DivLoaderChild } from "./card.styled";

export default function Card({title, dataCount, isLoading, onClick, warning}) {
    return (
        <>
            <DivCardContainer onClick={onClick}>
                <span className='title'>{title}</span>
                { isLoading ?
                    <DivLoaderContainer>
                        <DivLoaderChild/>
                    </DivLoaderContainer>
                    :
                    <span className={`data ${dataCount < warning ? 'green' : 'red'}`}>{dataCount}</span>
                }
            </DivCardContainer>
        </>
    )
}